module.exports = __webpack_public_path__ + "webfolder/assets/ebook/ytt-magazine/img/binoculars.4dbc45ea.svg";